import { MetalsPowderCoatingPowder } from "../models/metals-laser-material.model";

export function sortMetalsPowderCoatingPowderByColor(powders: MetalsPowderCoatingPowder[]): MetalsPowderCoatingPowder[] {
    return powders.sort((a, b) => {
        // HSV for a
        const resultA = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a.hexValue);
        let r = resultA ? parseInt(resultA[1], 16) : 0;
        let g = resultA ? parseInt(resultA[2], 16) : 0;
        let bb = resultA ? parseInt(resultA[3], 16) : 0;
        r /= 255;
        g /= 255;
        bb /= 255;
        const max = Math.max(r, g, bb);
        const min = Math.min(r, g, bb);
        const d = max - min;
        let h = 0;
        const s = (max === 0) ? 0 : d / max;
        const v = max;
        if (max !== min) {
            switch (max) {
                case r: h = (g - bb) / d + (g < bb ? 6 : 0); break;
                case g: h = (bb - r) / d + 2; break;
                case bb: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        const hA = h;
        const sA = s;
        const vA = v;

        // HSV for b
        const resultB = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(b.hexValue);
        r = resultB ? parseInt(resultB[1], 16) : 0;
        g = resultB ? parseInt(resultB[2], 16) : 0;
        bb = resultB ? parseInt(resultB[3], 16) : 0;
        r /= 255;
        g /= 255;
        bb /= 255;
        const maxB = Math.max(r, g, bb);
        const minB = Math.min(r, g, bb);
        const dB = maxB - minB;
        h = 0;
        const sB = (maxB === 0) ? 0 : dB / maxB;
        const vB = maxB;
        if (maxB !== minB) {
            switch (maxB) {
                case r: h = (g - bb) / dB + (g < bb ? 6 : 0); break;
                case g: h = (bb - r) / dB + 2; break;
                case bb: h = (r - g) / dB + 4; break;
            }
            h /= 6;
        }
        const hB = h;

        // compare
        if (hA !== hB) return hA - hB;
        if (sA !== sB) return sA - sB;
        return vA - vB;
    });
}